<template>
  <div class="quiz-container">
    <div class="quiz-header">
      <div class="header"></div>
    </div>
    <div class="quiz-instructions">
      <div class="box section" :style="boxSettings">
        <div class="tile is-size-3 margin" :style=" quizMessage">{{quizName}}</div>
     
        <div class="is-size-6-mobile is-size-4-tablet textColor has-text-centered mt-2" :style="quizLoginSettings" > The email ID you provided is not registered for the event. <span> Please <a :href="linkedEventUrl" target="_blank" :style="quizMessage"> register here </a> </span> to play the quiz. </div>
        <br />
         <div class="leadership-rank-title is-size-6 mt-3 has-text-centered"><a :href="'/'+quizUrl"><button class="button" :style="buttonSettings">Back</button></a></div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['quizUrl', 'quizName', 'linkedEventUrl','backgroundColor', 'primaryColor', 'textColor']),
     boxSettings(){
      return{
        "background-color": this.backgroundColor,
      }
    },
    buttonSettings(){
      return{
        "background-color": this.primaryColor,
        "border-color": this.primaryColor,
        "color": this.textColor
      }
    },
    quizLoginSettings(){
      return{
        "color": this.textColor
        
      }
    },
    quizMessage(){
      return{
        "color": this.primaryColor
        
      }
    }
  },
}

</script>

<style lang="scss" scoped>
.quiz-container {
  width: 100vw;
  height: 100vh;
  background-color: $app-background-color;

  .textColor{
    color: $brand-color;
  }

  .quiz-header {
    display: flex;
    justify-content: center;

    .header {
      font-size: 64px;
      line-height: 40px;
      color: $primary-color;
      padding: 4rem;
    }
    .timmer {
      font-size: 64px;
      line-height: 40px;
      color: $primary-color;
      padding: 4rem;
    }
  }

  .quiz-instructions {
    display: flex;
    justify-content: center;

    .button1{
      width: 200px;
    height: auto;
    font-size: 20px;
    }
    .box {
      background-color: $box-background-color;
      border-radius: 1.56rem;
      padding: 15px;
      max-width: 80rem;
      width: 80rem;
      min-height: 25rem;
      max-height: 25rem;
      display: flex;
      flex-direction: column;
      flex-grow: 0;
      align-items: unset;

      .tile {
        font-weight: bold;
        line-height: 40px;
        color: $primary-color;
        padding: 0.5rem;
        max-height: 4rem;
        overflow: hidden;
        display: flex;
        align-self: center;
      }
       .margin{
        margin-top: 100px;
      }
      hr {
        background-color: $primary-color;
        border-radius: 25px;
        margin: 0rem;
      }
      ol {
        list-style: none;
        counter-reset: my-awesome-counter;
        max-height: 16rem;
        color: $brand-color;
        overflow-y:auto;

        li {
          counter-increment: my-awesome-counter;
          display: flex;

          &:before {
            // display: inline-block;
            content: counter(my-awesome-counter)".";
            width:1.5rem;
            padding-right: 4px;
            text-align: right;
          }
        }
      }
      .center {
        display: flex;
        justify-content: center;
        &:focus {
          border: 1px solid $primary-color;
        }
        .button {
          border-radius: 20px;
          font-weight: 600;
          font-size: 16px;
          text-transform: uppercase;
          &:hover {
            color: $white;
          }
        }
      }
    }
  }
}
</style>
